// extracted by mini-css-extract-plugin
export default {"loading":"styles-module__loading__src-labstep-web-core-Websocket-_lnepP"};